export default __webpack_public_path__ + "static/petlink-99c8a9baaad942f5bad9811097c30931.svg";